<template>
  <div>
    <div class="sm:flex sm:items-start sm:justify-start sm:-mx-2">
      <div
        class="w-full sm:w-1/2 flex flex-col sm:px-2 fade-in"
        v-if="countries.length"
      >
        <select-floating-label>
          <div
            class="input-wrap label-floating"
            slot-scope="slotProps"
          >
            <select
              id="rep_country"
              class="w-full bg-gray-100 border-0 border-b border-gray-300 focus:border-black pl-3 pr-10 text-gray-900 leading-normal focus:outline-none transition-all duration-250"
              :class="[slotProps.hasValue ? 'pt-6 pb-2' : 'pt-4 pb-4']"
              @change="slotProps.setValue"
              v-model="country"
            >
              <option disabled></option>
              <option
                v-for="country in countries"
                :key="`c-${country.code}`"
                :value="country.code"
              >
                {{ country.name }}
              </option>
            </select>

            <label
              class="absolute block top-0 left-0 w-full px-3 pb-4 text-gray-800 leading-normal pointer-events-none duration-250 transition-all"
              :class="[slotProps.hasValue ? 'pt-2 text-xs' : 'pt-4']"
              for="rep_country"
            >
              Select Your Country <span class="text-red-500">*</span>
            </label>
          </div>
        </select-floating-label>
      </div>

      <!-- <div
        v-if="countries.length > 0 && !country"
        class="w-full sm:w-1/2 flex items-center self-center text-gray-500 px-2"
      >
        <svg class="inline-svg w-4 h-4 transform rotate-90 sm:rotate-0" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path></svg>
        <span class="ml-2 text-lg">Select a country</span>
      </div> -->

      <div
        class="w-full mt-8 sm:mt-0 sm:w-1/2 flex flex-col sm:px-2 fade-in"
        v-if="states.length"
      >
        <select-floating-label>
          <div
            class="input-wrap label-floating"
            slot-scope="slotProps"
          >
            <select
              id="rep_state_province"
              class="w-full bg-gray-100 border-0 border-b border-gray-300 focus:border-black pl-3 pr-10 text-gray-900 leading-normal focus:outline-none transition-all duration-250"
              :class="[slotProps.hasValue ? 'pt-6 pb-2' : 'pt-4 pb-4']"
              @change="slotProps.setValue"
              v-model="state"
            >
              <option disabled></option>
              <option
                v-for="state in states"
                :key="`s-${state.code}`"
                :value="state.code"
              >
                {{ state.name }}
              </option>
            </select>

            <label
              class="absolute block top-0 left-0 w-full px-3 pb-4 text-gray-800 leading-normal pointer-events-none duration-250 transition-all"
              :class="[slotProps.hasValue ? 'pt-2 text-xs' : 'pt-4']"
              for="rep_state_province"
            >
              Select Your State or Province <span class="text-red-500">*</span>
            </label>
          </div>
        </select-floating-label>
      </div>
    </div>

    <div
      class="fade-in mt-8"
      v-if="renderReps.length > 0"
    >
      <p class="text-lg leading-relaxed italic mb-8">
        In an effort to ensure you connect with your correct local Mayer rep, please review the
        options below sorted by geographic location. Furniture Manufacturers should contact the OEM
        rep listed, and Designers and End Users should contact the A&amp;D&nbsp;rep.
      </p>

      <ul class="list-none m-0 p-0">
        <li
          class="border-b border-gray-300 pb-6"
          :class="{ 'mt-6': a > 0 }"
          v-for="(region, a) in renderReps"
          :key="`r-${country}-${a}`"
        >
          <h3
            v-if="renderReps.length > 1"
            v-text="region.name"
          ></h3>

          <ul class="list-none m-0 p-0">
            <li v-for="(regionType, repType, b) in region.types">
              <div
                class="font-bold"
                :class="{ 'mt-4': b > 0 }"
                v-text="repType"
              ></div>

              <ul class="list-none m-0 p-0">
                <li
                  :class="{ 'mt-4': c > 0 }"
                  v-for="(rep, c) in regionType"
                >
                  <RepresentativeEntry :representative="rep">
                    <button
                      type="button"
                      class="underline hover:text-black"
                      @click="openContact(rep, repType, region.name)"
                    >
                      Contact
                    </button>
                  </RepresentativeEntry>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <focus-trap
      v-model="modal_open"
      :initial-focus="() => $refs['close-button']"
    >
      <modal
        class="z-top"
        max-width="40rem"
        :open="modal_open"
        @close="closeContact"
      >
        <template v-slot:trigger="triggerSlotProps">
          <button
            type="button"
            class="absolute top-0 right-0 flex items-center justify-center text-gray-400 hover:text-gray-600 w-10 h-10 z-10"
            @click.self="closeContact"
            ref="close-button"
          >
            <span class="sr-only">Close</span>
            <svg
              class="w-4 h-4 pointer-events-none"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"
              ></path>
            </svg>
          </button>
        </template>

        <template v-slot:default="defaultSlotProps">
          <div class="bg-white fade-in">
            <div class="border-b text-lg leading-tight pl-6 pr-10 py-4">
              Contact a representative
            </div>

            <div class="px-6 py-8">
              <RepresentativeEntry
                class="bg-white border border-gray-300 px-4 py-2 shadow-md"
                :representative="contact.to"
              ></RepresentativeEntry>

              <form
                class="mt-8"
                @submit.prevent="sendMessage"
                v-if="!message_sent"
              >
                <div class="relative mt-4 mb-4 appearance-none label-floating">
                  <input
                    type="text"
                    id="contact-from-name"
                    class="w-full bg-gray-100 border-0 border-b border-gray-300 focus:border-black py-4 px-3 text-gray-900 leading-normal focus:outline-none"
                    placeholder=" "
                    required
                    v-model="contact.from_name"
                  />
                  <label
                    class="absolute block text-gray-500 top-0 left-0 w-full px-3 py-4 leading-normal"
                    for="contact-from-name"
                  >
                    Name <span class="text-red-500">*</span>
                  </label>
                </div>

                <div class="relative mt-8 mb-4 appearance-none label-floating">
                  <input
                    type="email"
                    id="contact-from-email"
                    class="w-full bg-gray-100 border-0 border-b border-gray-300 focus:border-black py-4 px-3 text-gray-900 leading-normal focus:outline-none"
                    placeholder=" "
                    required
                    v-model="contact.from_email"
                  />
                  <label
                    class="absolute block text-gray-500 top-0 left-0 w-full px-3 py-4 leading-normal"
                    for="contact-from-email"
                  >
                    Email <span class="text-red-500">*</span>
                  </label>
                </div>

                <div class="relative mt-8 mb-4 appearance-none label-floating">
                  <input
                    type="text"
                    id="contact-from-phone"
                    class="w-full bg-gray-100 border-0 border-b border-gray-300 focus:border-black py-4 px-3 text-gray-900 leading-normal focus:outline-none"
                    placeholder=" "
                    required
                    v-model="contact.from_phone"
                  />
                  <label
                    class="absolute block text-gray-500 top-0 left-0 w-full px-3 py-4 leading-normal"
                    for="contact-from-phone"
                  >
                    Phone <span class="text-red-500">*</span>
                  </label>
                </div>

                <div class="relative mt-8 mb-4 appearance-none label-floating">
                  <input
                    type="text"
                    id="contact-from-company"
                    class="w-full bg-gray-100 border-0 border-b border-gray-300 focus:border-black py-4 px-3 text-gray-900 leading-normal focus:outline-none"
                    placeholder=" "
                    required
                    v-model="contact.from_company"
                  />
                  <label
                    class="absolute block text-gray-500 top-0 left-0 w-full px-3 py-4 leading-normal"
                    for="contact-from-company"
                  >
                    Company <span class="text-red-500">*</span>
                  </label>
                </div>

                <div class="relative mt-8 mb-4 appearance-none label-floating">
                  <input
                    type="text"
                    id="contact-from-address"
                    class="w-full bg-gray-100 border-0 border-b border-gray-300 focus:border-black py-4 px-3 text-gray-900 leading-normal focus:outline-none"
                    placeholder=" "
                    required
                    v-model="contact.from_address"
                  />
                  <label
                    class="absolute block text-gray-500 top-0 left-0 w-full px-3 py-4 leading-normal"
                    for="contact-from-address"
                  >
                    Address <span class="text-red-500">*</span>
                  </label>
                </div>

                <div class="relative mt-8 mb-4 appearance-none label-floating">
                  <input
                    type="text"
                    id="contact-from-city"
                    class="w-full bg-gray-100 border-0 border-b border-gray-300 focus:border-black py-4 px-3 text-gray-900 leading-normal focus:outline-none"
                    placeholder=" "
                    required
                    v-model="contact.from_city"
                  />
                  <label
                    class="absolute block text-gray-500 top-0 left-0 w-full px-3 py-4 leading-normal"
                    for="contact-from-city"
                  >
                    City <span class="text-red-500">*</span>
                  </label>
                </div>

                <div class="relative mt-8 mb-4 appearance-none label-floating">
                  <input
                    type="text"
                    id="contact-from-state"
                    class="w-full bg-gray-100 border-0 border-b border-gray-300 focus:border-black py-4 px-3 text-gray-900 leading-normal focus:outline-none"
                    placeholder=" "
                    required
                    v-model="contact.from_state"
                  />
                  <label
                    class="absolute block text-gray-500 top-0 left-0 w-full px-3 py-4 leading-normal"
                    for="contact-from-state"
                  >
                    State/Province <span class="text-red-500">*</span>
                  </label>
                </div>

                <div class="relative mt-8 mb-4 appearance-none label-floating">
                  <input
                    type="text"
                    id="contact-from-postal-code"
                    class="w-full bg-gray-100 border-0 border-b border-gray-300 focus:border-black py-4 px-3 text-gray-900 leading-normal focus:outline-none"
                    placeholder=" "
                    required
                    v-model="contact.from_postal_code"
                  />
                  <label
                    class="absolute block text-gray-500 top-0 left-0 w-full px-3 py-4 leading-normal"
                    for="contact-from-postal-code"
                  >
                    Postal Code <span class="text-red-500">*</span>
                  </label>
                </div>

                <div class="relative mt-8 mb-4 appearance-none label-floating">
                  <textarea
                    id="contact-message"
                    class="w-full bg-gray-100 border-0 border-b border-gray-300 focus:border-black py-4 px-3 text-gray-900 leading-normal focus:outline-none"
                    rows="5"
                    cols="50"
                    placeholder=" "
                    required
                    v-model="contact.message"
                  ></textarea>
                  <label
                    class="absolute block text-gray-500 top-0 left-0 w-full px-3 py-4 leading-normal"
                    for="contact-message"
                  >
                    Message <span class="text-red-500">*</span>
                  </label>
                </div>

                <div
                  class="text-red-800 italic mt-4"
                  v-if="error"
                  v-text="error"
                ></div>

                <div class="flex items-center mt-6">
                  <button
                    type="submit"
                    class="button button--primary w-36 h-16 flex items-center justify-center p-0"
                  >
                    <span v-if="!sending">Send</span>
                    <SvgLoader
                      v-else
                      size="2em"
                    ></SvgLoader>
                  </button>

                  <button
                    type="button"
                    class="button button--gray-outline w-36 h-16 flex items-center justify-center p-0 ml-4"
                    @click="closeContact"
                  >
                    Cancel
                  </button>
                </div>
              </form>

              <div
                class="w-full h-64 flex flex-col items-center justify-center"
                v-else
              >
                <div class="flex items-center">
                  <h3 class="leading-none my-0">Message Sent</h3>
                  <svg
                    class="inline-svg w-6 h-6 ml-2"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="currentColor"
                      d="M464 4.3L16 262.7C-7 276-4.7 309.9 19.8 320L160 378v102c0 30.2 37.8 43.3 56.7 20.3l60.7-73.8 126.4 52.2c19.1 7.9 40.7-4.2 43.8-24.7l64-417.1C515.7 10.2 487-9 464 4.3zM192 480v-88.8l54.5 22.5L192 480zm224-30.9l-206.2-85.2 199.5-235.8c4.8-5.6-2.9-13.2-8.5-8.4L145.5 337.3 32 290.5 480 32l-64 417.1z"
                    ></path>
                  </svg>
                </div>

                <button
                  type="button"
                  class="button button--gray-outline h-10 w-24 flex items-center justify-center p-0 mt-8"
                  @click="closeContact"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </template>
      </modal>
    </focus-trap>
  </div>
</template>

<script>
  import Modal from "@components/Common/Modal";
  import RepresentativeEntry from "@components/Representatives/RepresentativeEntry";
  import SelectFloatingLabel from "@components/Common/SelectFloatingLabel";
  import SvgLoader from "@components/Common/SvgLoader";
  import HasRoutes from "@/mixins/HasRoutes";
  import { FocusTrap } from "focus-trap-vue";

  const initialState = () => {
    return {
      contact: {
        from_address: null,
        from_city: null,
        from_company: null,
        from_email: null,
        from_name: null,
        from_phone: null,
        from_postal_code: null,
        from_state: null,
        to: {},
        message: null,
      },
      country: null,
      countries: [],
      error: null,
      message_sent: false,
      modal_open: false,
      regions: [],
      searching: true,
      sending: false,
      state: null,
      states: [],
    };
  };

  export default {
    name: "RepresentativeFinder",

    components: {
      FocusTrap,
      Modal,
      RepresentativeEntry,
      SelectFloatingLabel,
      SvgLoader,
    },

    mixins: [HasRoutes],

    data: () => initialState(),

    async created() {
      this.fetchCountries();
    },

    methods: {
      closeContact() {
        this.$set(this, "contact", Object.assign({}, initialState.contact));

        this.message_sent = false;

        this.modal_open = false;

        this.error = null;
      },

      async fetchCountries() {
        this.searching = true;

        await this.$http
          .get(this.route("representatives.fetch-countries"))
          .then((response) => {
            this.countries = response.data;
          })
          .catch((error) => {
            window.console.error(error);
          })
          .finally(() => {
            this.searching = false;
          });
      },

      async fetchRegions(location_type, location_id) {
        this.searching = true;

        await this.$http
          .get(this.route("representatives.fetch-regions"), {
            params: {
              id: location_id,
              type: location_type,
            },
          })
          .then((response) => {
            this.regions = response.data;
          })
          .catch((error) => {
            window.console.error(error);
          })
          .finally(() => {
            this.searching = false;
          });
      },

      async fetchStates() {
        await this.$http
          .get(this.route("representatives.fetch-states"), {
            params: {
              country: this.country,
            },
          })
          .then((response) => {
            this.states = response.data;
          })
          .catch((error) => {
            window.console.error(error);
          })
          .finally(() => {
            this.searching = false;
          });
      },

      openContact(rep, repType, region) {
        this.contact.to = Object.assign({}, rep);

        if (repType) {
          this.contact.to.repType = repType;
        }

        if (region) {
          this.contact.to.region = region;
        }

        this.modal_open = true;
      },

      async sendMessage() {
        this.error = null;
        this.sending = true;

        await this.$http
          .post(this.route("representatives.contact"), {
            from_address: this.contact.from_address,
            from_city: this.contact.from_city,
            from_company: this.contact.from_company,
            from_country: this.country,
            from_email: this.contact.from_email,
            from_name: this.contact.from_name,
            from_phone: this.contact.from_phone,
            from_postal_code: this.contact.from_postal_code,
            from_state: this.contact.from_state,
            message: this.contact.message,
            representative_id: this.contact.to.id,
          })
          .then((response) => {
            this.message_sent = true;

            window.gtag &&
              window.gtag("event", "submission", {
                event_category: "form",
                event_label: "representative_contact",
                value: this.country,
              });
          })
          .catch((error) => {
            this.error = "There was a problem sending your message. Please try again.";
          })
          .finally(() => (this.sending = false));
      },
    },

    computed: {
      renderReps() {
        return this.regions.reduce((carry, region) => {
          carry.push({
            name: region.name,
            types: region.representatives.reduce((carry, rep) => {
              (carry[rep["representative_type"]] = carry[rep["representative_type"]] || []).push(
                rep
              );

              return carry;
            }, {}),
          });

          return carry;
        }, []);
      },
    },

    watch: {
      country(newCountry) {
        Object.assign(this.$data, initialState(), {
          country: newCountry,
          countries: this.countries,
        });

        const country = this.countries.find((country) => country.code === newCountry);

        if (country.states_count > 0) {
          this.fetchStates();

          return;
        }

        if (country.regions_count > 0) {
          this.fetchRegions("Country", country.id);
        }
      },

      state(newState) {
        if (!newState) {
          return;
        }

        Object.assign(this.$data, initialState(), {
          country: this.country,
          countries: this.countries,
          state: newState,
          states: this.states,
        });

        const state = this.states.find((state) => state.code === newState);

        this.fetchRegions("State", state.id);
      },
    },
  };
</script>
